import { createSlice } from '@reduxjs/toolkit';
import { BootstrapperState, BootstrapStage } from './types';
import { STAGES } from './stages';
import { authActions } from '../auth/slice';

const initialState: BootstrapperState = {
  caption: 'Loading...',
  currentStage: BootstrapStage.LOCATE_PLUGIN,
  totalStages: Object.values(STAGES).length,
  ready: false
};

export const bootstrapperSlice = createSlice({
  name: 'bootstrapper',
  initialState,
  reducers: {
    setCaption: (state, action) => {
      state.caption = action.payload;
    },
    nextStage: (state) => {
      state.currentStage++;
    },
    isReady: (state) => {
      state.ready = true;
    },
    loadFailed: (state) => {
      state.failed = true;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(authActions.logOut, () => ({ ...initialState }));
  }
});

export const actions = bootstrapperSlice.actions;

export default bootstrapperSlice.reducer;
